export default "__VITE_ASSET__Dyyhri4S__"